module.exports = __webpack_public_path__ + "img/apple_store.7b6675c3.svg";